import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'

// Get All Meter Slabs
export const getMeterSlabsReq = (action) => {
    const params = action?.data || {};
    return axiosInstance.get(apiEndpoints.GET_METER_SLABS_API, { params })
}

// Get Meter Slabs by Head ID
export const getMeterSlabsByHeadReq = (action) => {
    const params = action?.data || {};
    return axiosInstance.get(apiEndpoints.GET_METER_SLABS_BY_HEAD_API, { params })
}

// Get Meter Slab Details by ID
export const getMeterSlabDetailsReq = (action) => {
    const { id } = action?.data || {};
    const url = apiEndpoints.GET_METER_SLAB_DETAILS_API.replace(':id', id);
    return axiosInstance.get(url)
}

// Create Meter Slab
export const createMeterSlabReq = (action) => {
    const payload = action?.data || {};
    const body = { ...payload };
    delete body.onSuccess;

    return axiosInstance.post(apiEndpoints.CREATE_METER_SLAB_API, body)
}

// Bulk Create Meter Slabs
export const createBulkMeterSlabsReq = (action) => {
    const payload = action?.data || {};
    const body = { ...payload };
    delete body.onSuccess;

    return axiosInstance.post(apiEndpoints.CREATE_BULK_METER_SLABS_API, body)
}

// Update Meter Slab
export const updateMeterSlabReq = (action) => {
    const payload = action?.data || {};
    const { id } = payload;
    const url = apiEndpoints.UPDATE_METER_SLAB_API.replace(':id', id);

    const body = { ...payload };
    delete body.id;
    delete body.onSuccess;

    return axiosInstance.put(url, body)
}

// Update Meter Slab Status
export const updateMeterSlabStatusReq = (action) => {
    const { id, status } = action?.data || {};
    const url = apiEndpoints.UPDATE_METER_SLAB_STATUS_API.replace(':id', id);

    return axiosInstance.patch(url, { status })
}

// Delete Meter Slab
export const deleteMeterSlabReq = (action) => {
    const { id } = action?.data || {};
    const url = apiEndpoints.DELETE_METER_SLAB_API.replace(':id', id);

    return axiosInstance.delete(url)
}
